(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/models/games.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/models/games.js');

'use strict';

const games = [{
  name: 'Stryktipset',
  urlName: 'gameResultsStryktipset',
  iconName: 'stryktipset'
}, {
  name: 'Europatipset',
  urlName: 'gameResultsEuropatipset',
  iconName: 'europatipset'
}, {
  name: 'Topptipset',
  urlName: 'gameResultsTopptipset',
  iconName: 'topptipset'
}, {
  name: 'Måltipset',
  urlName: 'gameResultsMaltipset',
  iconName: 'maltipset'
}, {
  name: 'Fullträff',
  urlName: 'gameResultsFulltraff',
  iconName: 'fulltraff',
  ftName: ''
}, {
  name: 'Bomben',
  urlName: 'gameResultsBomben',
  iconName: 'bomben'
}, {
  name: 'Challenge',
  urlName: 'gameResultsChallenge',
  iconName: 'challenge'
}, {
  name: 'Matchen',
  urlName: 'gameResultsMatchen',
  iconName: 'matchen'
}, {
  name: 'Powerplay',
  urlName: 'gameResultsPowerplay',
  iconName: 'powerplay'
}];
svs.game_results.models.Games = Backbone.Model.extend({
  defaults: {
    games
  }
});

 })(window);